import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AddEditProductiveCycleModal from './Add_Edit/AddEditProductiveCycle';
import DeleteProductiveCycleModal from './Delete/DeleteProductiveCycle';
import { getProductiveCycleList } from '../../slices/productiveCycle/thunk';
import { ODataGrid } from '../../Components/OElements/ODataGrid';

const ProductiveCyclesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorCategories = createSelector(
		state => state.ProductiveCycle,
		data => ({
			dataList: data.itemProductiveCycleList,
			isLoadingList: data.isLoadingList,
			isProductiveCycleSuccess: data.isProductiveCycleSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { dataList, isLoadingList } = useSelector(selectorCategories);

	useEffect(() => {
		dispatch(getProductiveCycleList());
	}, []);

	const [dataProductiveCycle, setDataProductiveCycle] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete ProductiveCycle
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = data => {
		setDataProductiveCycle(data);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = data => {
		setDataProductiveCycle(data);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'categories',
				columnDefType: 'display',

				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const dataData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(dataData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const dataData = cellProps.row.original;
													handleClickDelete(dataData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Código', accessorKey: 'code', size: 'auto' },
			{
				header: 'Estado',
				accessorKey: 'productive_cycle_status.name',
				size: 'auto',
				dataType: 'multi-select',
				Cell: ({ row }) => {
					let status = row.original.productive_cycle_status;
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgColor, color: txColor }}
							>
								{status ? status.name : ''}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Etapa de Ciclo Productivo',
				accessorKey: 'productive_cycle_stage.name',
				size: 'auto',
				dataType: 'multi-select',
				Cell: ({ row }) => {
					const stage = row.original?.productive_cycle_stage;

					if (!stage) {
						return <span>-</span>; // Sin estilos si no hay stage
					}

					return (
						<div>
							<span
								className='badge'
								style={{ backgroundColor: stage.bgcolor, color: stage.txcolor }}
							>
								{stage.name}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Tipo de Establecimiento',
				accessorKey: 'establishment_type.name',
				dataType: 'multi-select',
				size: 'auto',
			},
			// { header: 'Establecimiento', accessorKey: 'establishment.name',  size: 'auto', },
			{
				header: 'Establecimiento',
				accessorKey: 'establishment.name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					return (
						<span
							onClick={() =>
								window.open(
									`/establishment/summary/${row.original.establishment_id}`,
									'_blank'
								)
							}
							style={{
								cursor: 'pointer',
								color: 'var(--vz-primary)',
								textDecoration: 'none',
								fontWeight: 'bold',
							}}
						>
							<i className='ri-links-line'></i>{' '}
							{row?.original?.establishment?.name}
						</span>
					);
				},
			},

			{
				header: 'SIEP',
				accessorKey: 'establishment.code_siep',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Artefacto Naval',
				accessorKey: 'feeding_barges',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					const establishmentType = row?.original?.establishment_type?.code;
					const feedingBargeName = row?.original?.feeding_barges;

					return feedingBargeName
						? feedingBargeName
						: establishmentType !== 'FWE'
							? '-'
							: 'N/A';
				},
			},
			{
				header: 'Especie',
				accessorKey: 'species',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Tipo de Cultivo',
				accessorKey: 'crop_type.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Inicio',
				accessorKey: 'date_ini',
				size: 'auto',
				dataType: 'date',
			},
			{
				header: 'Término',
				accessorKey: 'date_end',
				size: 'auto',
				dataType: 'date',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataProductiveCycle({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Ciclo Productivo
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={dataList || []}
								// masterDetailComponent={({ row }) => (
								// 	<ActivitiesMasterDetail data={row.original} />
								// )}
								isLoadingData={isLoadingList}
								nameFile={'ciclo_productivo'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										className: 'gap-1',
										onClick: () => {
											setIsEdit(false);
											setDataProductiveCycle({});
											handleToggleModal();
										},
										title: 'Crear Ciclo Productivo',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditProductiveCycleModal
				dataProductiveCycle={dataProductiveCycle}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteProductiveCycleModal
				dataProductiveCycle={dataProductiveCycle}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ProductiveCyclesList;
